import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, breakpoints, themeName, spacing }) => ({
  stepperRoot: {
    padding: spacing(0, 0, 8, 0),
    [breakpoints.up('sm')]: {
      padding: spacing(5)
    }
  },
  root: {
    width: 24,
    fontWeight: 700,
    border: 'none',
    color: palette.common.stepperCompleted,
    ...(themeName === 'dacia' && {
      border: `1px solid ${palette.common.stepperCompletedText}`,
      borderRadius: '50%',
      height: 24
    }),
    '& text': {
      fill: palette.common.stepperCompletedText
    },
    '&$active': {
      color: palette.common.stepperActive,
      ...(themeName === 'dacia' && {
        border: 0,
        height: 26,
        width: 26
      }),
      '& text': {
        fill: palette.common.stepperActiveText
      }
    },
    '&$completed': {
      ...(themeName === 'dacia' && {
        border: 0,
        height: 26,
        width: 26
      })
    }
  },
  active: {},
  completed: {},
  iconText: {
    fontFamily: themeName === 'dacia' ? 'Read' : 'NouvelR',
    fontSize: themeName === 'dacia' ? 14 : 16,
    lineHeight: '22px'
  },
  label: {
    color: palette.common.stepperCompletedText,
    '&$alternativeLabel': {
      marginTop: 0,
      fontSize: 16,
      fontWeight: 500,
      display: 'none',

      [breakpoints.up('sm')]: {
        display: 'block'
      }
    }
  },
  alternativeLabel: {},
  stepRoot: {
    cursor: 'pointer'
  }
}));
